var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeacock1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168 70H154V84H168V70Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 56H140V70H154V56Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 56H126V70H140V56Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 56H112V70H126V56Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 70H112V84H126V70Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 84H126V98H140V84Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 98H140V112H154V98Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 112H154V126H168V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 126H154V140H168V126Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 140H140V154H154V140Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 154H126V168H140V154Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 154H112V168H126V154Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 154H98V168H112V154Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 140H84V154H98V140Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 126H70V140H84V126Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 112H84V126H98V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 112H98V126H112V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 112H112V126H126V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 112H126V126H140V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 112H56V126H70V112Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 98H42V112H56V98Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 84H28V98H42V84Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 70H14V84H28V70Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 56H0V70H14V56Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 42H0V56H14V42Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 28H14V42H28V28Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 84H56V98H70V84Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 70H70V84H84V70Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 56H84V70H98V56Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 42H84V56H98V42Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 28H70V42H84V28Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 14H28V28H42V14Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 0H42V14H56V0Z",
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 14H56V28H70V14Z",
    fill: "#929292"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeacock1);
export default __webpack_public_path__ + "static/media/peacock1.3aeb32ba02f8741d4213cb9ee1d104d6.svg";
export { ForwardRef as ReactComponent };